import ActivityForm from './activity-form';

export default ActivityForm;